<template>
  <div class="tw-bg-white tw-rounded-md tw-p-8">
    <!-- <h5 class="tw-font-semibold tw-mb-3">Plans</h5> -->
    <table-component
      :items="items"
      :fields="fields"
      @edit="familyFunc($event, 'edit')"
      @delete="deleteRecord"
      :busy="busy"
      @view="view"
      :paginate="false"
      :showBaseCount="false"
    >
      <template #button>
        <!-- <router-link to="/enrollee/create"> -->
        <button class="veo-btn veo-primary" @click="familyFunc('create')">
          Create Family
        </button>
        <!-- </router-link> -->
      </template>
    </table-component>

    <add-new-family
      :visible="visible"
      @completeAdd="completeAdd"
      @handleClose="closeModal"
      :item="item"
      :editMode="editMode"
      :title="title"
    />
  </div>
</template>

<script>
import TableComponent from "@/components/TableComponent.vue";
import AddNewFamily from "@/components/modals/users/FamilyModal.vue";
export default {
  components: { TableComponent, AddNewFamily },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "user",
          label: "User Name",
          formatter: (item) => {
            return item === null ? '---' : `${item.first_name} ${item.last_name}`
          }
        },

        {
          key: "dependents",
          label: "Number of dependents",
          formatter: (item) => {
            return item.length
          }
        },
        // {
        //   key: "price",
        //   label: "Price",
        //   formatter: (item) => {
        //     return item
        //       ? Number(item).toLocaleString("en-US", {
        //           style: "currency",
        //           currency: "NGN",
        //         })
        //       : "NGN 0.00";
        //   },
        // },
        {
          key: "actions",
          label: "",
        },
      ],
      busy: false,
      visible: false,
      mode: null,
      item: {},
      editMode: false,
      title: null,
    };
  },
  methods: {
    list() {
      this.busy = true;
      this.$users
        .getFamilies()
        .then((res) => {
          console.log(res.data, "valid");
          this.items = res.data;
          this.busy = false;
        })
        .catch((err) => {
          console.log(err);
          this.busy = false;
        });
    },

    familyFunc(e, value) {
      this.mode = value;
      console.log(value, e, "kkkk");
      if (value === "create") {
        this.visible = !this.visible;
        this.title = "Create New Family";
        this.editMode = false;
      } else if (value === "edit") {
        this.visible = !this.visible;
        this.item = e;
        this.editMode = true;
        this.title = `Update Family`;
      } else {
        this.visible = !this.visible;
        this.editMode = false;
        this.title = "Create New Family";
      }
    },

    complete(value) {
      this.$inventory
        .deletePlan(value.id)
        .then((res) => {
          this.$swal.fire("Deleted!", "Plan deleted succesfully.", "success");
          this.list();
          return res;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteRecord(value) {
      this.$swal
        .fire({
          title: "Are you Sure? 🤔",
          text: "This action is irreversible!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          console.log(result, "kkk");
          if (result.isConfirmed) {
            this.complete(value);
          }
        });
    },

    closeModal() {
      this.visible = !this.visible;
      this.item = {};
      this.editMode = false;
      this.title = null;
    },

    completeAdd() {
      this.visible = !this.visible;
      this.list();
    },

    view(e) {
      this.$router.push(`/family/view/${e.id}`);
    },
  },

  beforeMount() {
    this.list();
  },
};
</script>

<style></style>
